import type { FC, ReactNode } from 'react';

import { ErrorBoundary } from '../../errorBoundary';
import { Loader } from '../../loader';

import styles from './Chat.module.css';

interface ChatProps {
  chatTabs: ReactNode;
  messagesWrapper: ReactNode;
  chatFooter: ReactNode;
}

export const Chat: FC<ChatProps> = ({ chatTabs, messagesWrapper, chatFooter }) => {
  return (
    <ErrorBoundary fallback={<Loader />}>
      <div data-testid="chat" className={styles.chat}>
        {chatTabs}
        {messagesWrapper}
        {chatFooter}
      </div>
    </ErrorBoundary>
  );
};
